import { AdministrationService } from "./services/AdministrationService";
import { DepartmentService } from "./services/DepartmentService";

const apiUrl = process.env.REACT_APP_API_URL;

export const administrationService = new AdministrationService(apiUrl);
export const departmentService = new DepartmentService(apiUrl);
